import img1 from "../assets/1.png";
import img2 from "../assets/2.png";
import img3 from "../assets/3.png";
import img4 from "../assets/4.png";
import img5 from "../assets/5.png";
import img6 from "../assets/6.png";
import img7 from "../assets/7.png";
import img8 from "../assets/8.png";
import img9 from "../assets/9.png";

export const TipsData = [
    {
    image: img1
    },
    {
    image: img2
    },
    {
    image: img3
    },
    {
    image: img4
    },
    {
    image: img5
    },
    {
    image: img6
    },
    {
    image: img7
    },
    {
    image: img8
    },
    {
    image: img9
    }
  ];